import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { caAPI, saveBlob } from '../../lib/complianceAutoAPI';

const Cell = ({ v, onClick, tid }) => <TableCell className={v ? 'underline cursor-pointer' : ''} onClick={v ? onClick : undefined} data-testid={tid}>{v}</TableCell>;

export const WorkloadTable = ({ go }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { caAPI.workload().then(setRows).catch(() => {}); }, []);
  const td = new Date();
  const plus = (n) => new Date(td.getTime() + n * 864e5).toISOString().slice(0, 10);
  return (
    <div className="border rounded-md" data-testid="ca-workload">
      <div className="flex items-center justify-between p-2"><h3 className="text-sm font-semibold">Staff workload</h3>
        <Button size="sm" variant="outline" className="h-7" onClick={() => caAPI.exportWorkload().then((b) => saveBlob(b, 'compliance-workload.csv'))} data-testid="ca-workload-export">Export CSV</Button></div>
      <Table><TableHeader><TableRow>{['Staff', 'Open', 'By stage', 'Due 7d', 'Due 14d', 'Due 30d', 'Overdue', 'Awaiting docs', 'Lodged this quarter'].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>{rows.map((r) => {
          const a = { assignee_id: r.assignee_id };
          return (<TableRow key={r.assignee_id} data-testid={`ca-wl-${r.assignee_id}`}>
            <TableCell>{r.assignee}</TableCell>
            <Cell v={r.open} onClick={() => go(a)} tid={`ca-wl-open-${r.assignee_id}`} />
            <TableCell className="text-xs">{Object.entries(r.by_stage).map(([k, v]) => <button key={k} type="button" className="underline mr-2" onClick={() => go({ ...a, stage: k })}>{k}: {v}</button>)}</TableCell>
            {[7, 14, 30].map((n) => <Cell key={n} v={r[`due_${n}`]} onClick={() => go({ ...a, due_from: plus(0), due_to: plus(n) })} tid={`ca-wl-due${n}-${r.assignee_id}`} />)}
            <Cell v={r.overdue} onClick={() => go({ ...a, overdue: 'true' })} tid={`ca-wl-overdue-${r.assignee_id}`} />
            <Cell v={r.awaiting_docs} onClick={() => go({ ...a, stage: 'awaiting_docs' })} tid={`ca-wl-awaiting-${r.assignee_id}`} />
            <TableCell>{r.lodged_this_period}</TableCell></TableRow>);
        })}</TableBody></Table>
    </div>
  );
};
